import { MdCardGiftcard } from 'react-icons/md';
import PlusIcon from '@rsuite/icons/Plus';
import { CustomButton } from '../../../../components/CustomButton';
import { useCustomTheme } from '../../../../hooks/useCustomTheme';
import { styles } from './styles';

export function EmptyState({ onOpenAddModal }) {
  const { theme } = useCustomTheme();

  return (
    <div style={styles.container}>
      <div style={{ ...styles.iconWrapper, color: theme.colors.primary }}>
        <MdCardGiftcard size={34} />
      </div>
      <span style={styles.title}>Nenhum programa de fidelidade cadastrado</span>
      <span style={styles.description}>
        Crie um programa de cashback, selos por pedido ou valor acumulado para fidelizar seus
        clientes.
      </span>
      <CustomButton appearance="primary" onClick={onOpenAddModal}>
        <PlusIcon style={{ marginRight: 6 }} />
        Adicionar Fidelidade
      </CustomButton>
    </div>
  );
}
